import { Role } from '@/models/AccountEnums';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';

const isAdvisorRole = (role: Role | undefined): boolean =>
  String(role).toLowerCase() === 'advisor';

export const advisorRequiresInvestorId = (
  role: Role | undefined,
  investorId?: number,
): boolean => isAdvisorRole(role) && typeof investorId !== 'number';

export const advisorScopeMissingError = (): FetchBaseQueryError => ({
  status: 'CUSTOM_ERROR',
  error: 'InvestorId is required for advisor role',
});

export const requireInvestorIdForAdvisor = (
  role: Role | undefined,
  investorId?: number,
): number | undefined => {
  if (!isAdvisorRole(role)) {
    return investorId;
  }
  return typeof investorId === 'number' ? investorId : undefined;
};

export const isAdvisorAggregateEndpoint = (url: string): boolean => {
  const normalized = url.toLowerCase();
  return (
    normalized.includes('/api/advisor') &&
    !/\/api\/advisor\/investors\/\d+/.test(normalized)
  );
};
